<ng-content />

<div
  class="menu-container"
  tabindex="-1"
  (mouseover)="onMenuMouseOver($event)"
  (mouseleave)="onMenuMouseLeave()"
  (focus)="onMenuFocusIn($event)"
  (blur)="onMenuMouseLeave()"
  (click)="onMenuMouseLeave()"
  (keydown)="onMenuMouseLeave()"
>
  <dx-tree-view
    [items]="items()"
    keyExpr="path"
    selectionMode="single"
    [focusStateEnabled]="false"
    expandEvent="click"
    (onItemClick)="onItemClick($event)"
    width="100%"
    noDataText="Loading..."
  >
    <div *dxTemplate="let item of 'inquiriesBadge'" class="nav-badge-item">
      <i class="dx-icon dx-icon-{{ item.icon }}"></i>
      <span>{{ item.text }}</span>
      @if (item.badge > 0) {
        <div class="dx-badge">{{ item.badge }}</div>
      }
    </div>
  </dx-tree-view>
</div>

<dx-tooltip [position]="tooltipPosition">
  <div *dxTemplate="let data of 'content'">
    {{ tooltipText() }}
  </div>
</dx-tooltip>

@if (showMenuToggle()) {
  <dx-button
    class="menu-pin-toggle"
    stylingMode="text"
    [icon]="compactMode() ? 'chevronnext' : 'chevronprev'"
    (onClick)="menuToggle.emit()"
  />
}
